import { httpRequest } from "@/lib/axios";
import { FinanceAccount } from "@/types";
import { useQuery } from "@tanstack/react-query";

async function fetchFinanceAccountById(id: string): Promise<FinanceAccount> {
  const response = await httpRequest.get<FinanceAccount>(
    `/finance-accounts/${id}`
  );
  return response.data;
}

export function useFetchFinanceAccountByIdQuery(id: string) {
  return useQuery({
    queryKey: ["finance-account", id],
    queryFn: () => fetchFinanceAccountById(id),
    enabled: !!id,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
}
